import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { nkServices } from './componentes/shared/servicios/app.nkservicios.services';
import {MatDialog } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {FormLoginComponent} from './componentes/shared/modal/form-login/form-login.component';
import { FormSpinnerComponent } from './componentes/shared/modal/form-spinner/form-spinner.component';
import { HashKeyServices } from './componentes/shared/servicios/app.hashkey.services';
import { FormVersionComponent } from './componentes/shared/modal/form-version/form-version.component';
import { environment } from 'src/environments/environment';
import { AppUtilService } from './componentes/shared/servicios/app.util.service';
import { AtributosService } from './componentes/shared/servicios/atributos.service';
import { ToastNotificationService } from './componentes/shared/servicios/toast-notification.service';
import { FormRecuperacionComponent } from './componentes/shared/modal/form-recuperacion/form-recuperacion.component';
import { TemasService } from './componentes/shared/servicios/temas.service';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit {

  idleState:any;
  timedOut = false;
  lastPing?: Date = null;
  title = 'VectorNerd';
  valor:any = false;
  cod_sesion:any;
  auth_sesion:any = false;
  value:any;
  dialogSpin:any;
  accion:any;
  valoroff:any;
  tiempo:any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  horizontalPosition1: MatSnackBarHorizontalPosition = 'center';
  verticalPosition1: MatSnackBarVerticalPosition = 'top';
  environment = environment;
  empresa:any;
  constructor(
    private servicio:nkServices,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router:Router,
    private idle: Idle,
    private keepalive: Keepalive,
    private hashkey:HashKeyServices,
    private util:AppUtilService,
    private atrb:AtributosService,
    private notifi:ToastNotificationService,
    private tem:TemasService,
    ){
    }
  reset() {
    this.idle.watch();
  }
 qwidle(){
  this.valoroff = localStorage.getItem('cod_usuario');
  if (this.valoroff) {
/////////////TIEMPO DE INACTIVIDAD/////////////////
  this.idle.setIdle(1000);
/////////////TIEMPO DE INACTIVIDAD/////////////////
/////////////TIEMPO DE PARA CANCELAR LA ACCION/////////////////
  this.idle.setTimeout(10);
/////////////TIEMPO DE PARA CANCELAR LA ACCION/////////////////
  this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

  this.idle.onIdleEnd.subscribe(() => {});
  this.idle.onTimeout.subscribe(() => {
    this.timedOut = true;
  });
  this.idle.onIdleStart.subscribe(() =>
  this.notifi.customToastNotification(this.atrb.MENSAJES_FIJOS.tiempo_espera));
  this.idle.onTimeoutWarning.subscribe((countdown) => {this.idleState = 'You will time out in ' + countdown + ' seconds!'
      if (countdown <= 1) {
        this.util.quitarLocalStorage();
        this.auth_sesion = false;
         window.location.reload();
      }
    }
    );
  this.keepalive.interval(15);
  this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
  this.reset();
  }else{
    this.idle.watch();
    this.idle.stop();
  }
 }
 async ngOnInit(){
  this.inicializar();
  }
async inicializar(){
    try {
      if (await this.isAuthenticated()) {
            await  this.servicio.consultar_sesionhttp(null).toPromise();
            this.auth_sesion = true;
           this.qwidle();
           this.empresa = localStorage.getItem('cod_empresa');
           this.router.navigate(['/mrkt']);
          
          await this.notifi.success('Bienvenid@: " '+await this.hashkey.decrypt(this.atrb.NOMBRE_USUARIO.nombre));
      }else{
          let xvalor = {
            cod_app: await this.hashkey.encrypt(environment.path_token),
            api: await this.hashkey.encrypt(await this.atrb.API_REST.validarApp)
          };
          const response = await  this.servicio.ApiResthttp(xvalor).toPromise();
        let ruta = await this.util.agregarLocalStorageApp(response);
                    await this.qwidle();
          this.empresa = localStorage.getItem('cod_empresa');
          this.router.navigate(['mrkt',localStorage.getItem('cod_empresa')]);
        /* this.permisosUsuarios(); */
      }
    } catch (error) {
      console.log(error);
              await this.notifi.customToastNotification(error.error.message);
            await this.cerrarsesion();
    }
  }

 async permisosUsuarios(){
    try {
      var dialogRef = this.dialog.open(FormLoginComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'pedidos_modal_login'
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.proceso.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          this.consultarusuario(result);
          this.qwidle();
        }else{
          await this.util.cerrarSpinner();
          this.recuperarPass();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async recuperarPass(){
    try {
      var dialogRef = this.dialog.open(FormRecuperacionComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'pedidos_modal'
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.proceso.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          location.reload();
        }else{
          await this.util.cerrarSpinner();
          location.reload();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
 async consultarusuario(usuario:any){
    try {
      await this.util.abrirSpinner();
       const response = await  this.servicio.loginhttp(usuario).toPromise();
          await  this.util.agregarLocalStorage(response);
          /* this.title = localStorage.getItem(); */
         this.auth_sesion = true;
          await this.qwidle();
         /* this.router.navigate(['/inicio']); */
         await this.util.cerrarSpinner();
         location.reload();
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
         await this.qwidle();
          location.reload();
    }
  }
  async cerrarsesion(){
    try {
      await this.util.abrirSpinner();
      this.auth_sesion = false;
     await this.servicio.cerrar_sesionhttp(null).toPromise();
          await this.util.quitarLocalStorage();
            this.valoroff = false;
            this.qwidle();
            await this.util.cerrarSpinner();
            window.location.reload();
    } catch (error) {
      this.auth_sesion = false;
      this.valoroff = false;
      await this.util.quitarLocalStorage();
      this.qwidle();
      await this.util.cerrarSpinner();
      window.location.reload();
    }
  }
  async cambiarTema(){
    try {
      await this.util.abrirSpinner();
        this.tem.toggleTheme();
      await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }

   isAuthenticated(): boolean {
    this.tiempo = JSON.parse(localStorage.getItem('tiempo'));
    return new Date().getTime() < this.tiempo;
  }
}
